import consolv from 'lib/consolv';
import checkVisibility from 'lib/checkVisibility';
// import { throttle } from 'lodash';

const defaultConfig = {
  // throttleWaitDuration: 400,
  distanceFromViewport: 500,
};

/**
 * Tracks position of unrendered ad slots in comparison to the viewport, and loads them when
 * they reach a defined threshold
 */
export default function lazyLoader(MCP) {
  MCP.addEventListener('ready', () => {
    consolv.log('MCP: Lazy loader initialized');
    const config = MCP.Configurator.getConfiguration();
    const lazyLoaderConfig = { ...defaultConfig, ...config.lazyLoader };
    const { distanceFromViewport } = lazyLoaderConfig;

    const checkSlots = () => {
      const slotsToLoad = Array.from(MCP.slots.values())
        .filter(slot => (
          (slot.enabled !== false) && 
          slot.creative &&
          slot.creative.isEmpty &&
          slot.getMetaData('shouldLazyLoad') &&
          !slot.getMetaData('loaded') &&
          (checkVisibility(slot.element) !== false) &&
          (slot.distanceFromViewport < distanceFromViewport)
        ));

      slotsToLoad.forEach((slot) => { slot.setMetaData('loaded', true); });
      if (slotsToLoad.length) {
        MCP.refreshSlots(slotsToLoad);
        consolv.log('MCP: Lazy loading slots', slotsToLoad);
      }
    };

    // const throttledCheckSlots = throttle(checkSlots, throttleWaitDuration);

    checkSlots();
    MCP.addEventListener('slotCreated', checkSlots);
    document.addEventListener('scroll', checkSlots);
    MCP.addEventListener('foundSlots', checkSlots);
  });
}